/**
 * Filter for Profile Name it the name is too long
 */
const filter = () => {
    return (input) => {
        let output = angular.isDefined(input) ? input : "";
        if (output.length > 15) {
            return output.substring(0, 15) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const ProfileFilter = {
    name: 'profileFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-profile.filter.js.map